// extracted by mini-css-extract-plugin
export default {"table":"SoldItemsBlock_table__u0W5w","tabs":"SoldItemsBlock_tabs__JL8Oh"};